import {
  Content,
  ContentCriterionType,
  ContentValidationCriterion,
  ProductError,
  ProductErrorType,
} from '../../models';

export class ClickableSchemaData {
  imageSrc: string;
  clickableItems: ClickableSchemaItem[];
  validationCriteria: ContentValidationCriterion[];
  title?: string;
  constructor(data?: ClickableSchemaData) {
    this.imageSrc = data?.imageSrc || '';
    this.clickableItems = (data?.clickableItems || []).map(item => new ClickableSchemaItem(item));
    this.title = data?.title || null;

    this.validationCriteria = data
      ? (data?.validationCriteria || []).map(vc => new ContentValidationCriterion(vc))
      : [new ContentValidationCriterion({ type: ContentCriterionType.CLICK_ALL })]; // as default value only for initial creation
  }

  static validate(schemaData: ClickableSchemaData, payloadData?: any): ProductError[] {
    const productErrors: ProductError[] = [];
    if (!schemaData.imageSrc) {
      productErrors.push({
        type: ProductErrorType.MISSING,
        property: 'imageSrc',
        payload: { ...(payloadData ? payloadData : {}) },
      });
    }

    if (!schemaData.clickableItems || !schemaData.clickableItems.length) {
      productErrors.push({
        type: !schemaData.clickableItems.length ? ProductErrorType.NOT_ENOUGH_VALUE : ProductErrorType.MISSING,
        property: 'clickableItems',
        payload: { ...(payloadData ? payloadData : {}) },
      });
      return productErrors;
    }
    schemaData.clickableItems.forEach((item, itemIndex) =>
      ClickableSchemaItem.validate(item, { ...(payloadData ? payloadData : {}), itemIndex }).forEach(error =>
        productErrors.push(error),
      ),
    );
    return productErrors;
  }
}

export class ClickableSchemaItem {
  posX: number;
  posY: number;
  title: string;
  contents: Content[];

  constructor(item?: ClickableSchemaItem) {
    if (item) {
      this.posX = item.posX;
      this.posY = item.posY;
      this.title = item.title;
      this.contents = (item.contents || []).map(c => new Content(c));
    } else {
      this.posX = 0;
      this.posY = 0;
      this.title = null;
      this.contents = [];
    }
  }

  static validate(clickableItem: ClickableSchemaItem, payloadData?: any): ProductError[] {
    const productErrors: ProductError[] = [];
    if (!clickableItem.title?.length) {
      productErrors.push({
        type: ProductErrorType.MISSING,
        property: 'title',
        payload: { ...(payloadData ? payloadData : {}) },
      });
    }

    if (clickableItem.contents?.length) {
      clickableItem.contents.forEach((content, contentIndex) => {
        Content.validate(content, contentIndex, { ...(payloadData ? payloadData : {}), contentIndex }).forEach(err =>
          productErrors.push(err),
        );
      });
    } else {
      productErrors.push({
        type: !clickableItem.contents.length ? ProductErrorType.NOT_ENOUGH_VALUE : ProductErrorType.MISSING,
        property: 'contents',
        payload: { ...(payloadData ? payloadData : {}) },
      });
    }

    return productErrors;
  }
}

export class ClickableSchemaItemModalContent {
  item: ClickableSchemaItem;
  validationCriteria: ContentValidationCriterion[];
  openTimeInSeconds: number;

  constructor(content: ClickableSchemaItemModalContent) {
    this.item = new ClickableSchemaItem(content?.item);
    this.validationCriteria = (content?.validationCriteria || []).map(v => new ContentValidationCriterion(v));
    this.openTimeInSeconds = content?.openTimeInSeconds || 0;
  }
}

export class ClickableSchemaProgression {
  clickableSchemaItemProgressionList: ClickableSchemaItemProgression[];
}
export class ClickableSchemaItemProgression {
  posX: number;
  posY: number;
  timerInSeconds: number;

  constructor(cardModalProgression?: ClickableSchemaItemProgression) {
    this.posX = cardModalProgression?.posX ?? null; // 0 are valid values
    this.posY = cardModalProgression?.posY ?? null; // 0 are valid values
    this.timerInSeconds = cardModalProgression?.timerInSeconds || null;
  }
}
